import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=2dbd0e2e&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbd0e2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2dbd0e2e')) {
      api.createRecord('2dbd0e2e', component.options)
    } else {
      api.reload('2dbd0e2e', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=2dbd0e2e&scoped=true&", function () {
      api.rerender('2dbd0e2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2DnNbf2NNTfwz/JS/comp/SearchFilterTokens.vue"
export default component.exports